import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NewModalService } from "@edp-pages/requests-and-operations/services/new-modal.service";
import { EdpPaymentAgreementService } from "@edp-services/edp-payment-agreement.service";
import { EdpSteperService } from "@edp-services/edp-steper.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "reject-agreement",
    templateUrl: "./reject-agreement.component.html",
    styleUrls: ["./reject-agreement.component.scss"],
})
export class RejectAgreementComponent  implements OnInit {
    @Input() onRedirectUrl: string;

    public isPage: boolean;

    constructor (
        private router: Router,
        private steperService: EdpSteperService,
        private readonly modalService: NewModalService,
        private readonly translateService: TranslateService,
        private edpPaymentAgreementService: EdpPaymentAgreementService,
    ) { 
        this.isPage = this.edpPaymentAgreementService.getBottomBarValue();
    }
    
    ngOnInit(): void {
        this.steperService.setActiveStep(4);
    }

    close() {
        if(this.onRedirectUrl) {
            this.router.navigate([this.onRedirectUrl]);
        } else {
            this.redirect();
        }
    }

    redirect() {
        if (this.isPage) {
            this.goToRequestAndOperations();
        } else {
            this.goToExternalUrl();
        }
    }

    public goToRequestAndOperations() {
        this.modalService.closeModal();
    }

    public goToExternalUrl() {
        const url = this.translateService.instant("pt.edp.edponline.payment.agreement.url.edp");
        window.location.href = url;
    }

}